import * as angular from "angular";
import {IController} from "angular";

export class FulfillmentLineAttemptsInfoTableComponent implements IController {

  attempts: any;
  onOpenAttemptInfoDialog: Function;

  constructor() {
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineAttemptsInfoTable', {
    bindings: {
      attempts: '<',
      onOpenAttemptInfoDialog: '&'
    },
    template: require('./fulfillment-line-attempts-info-table.html').default,
    controller: FulfillmentLineAttemptsInfoTableComponent
  });
